import { FC, ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { formatHumanReadableDate } from "@/modules/notification-center/utility";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const NotificationsWrapper: FC<{
  date: string;
  children: ReactNode;
}> = ({ date, children }) => {
  const displayDate = formatHumanReadableDate(date);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
          px: "26px",
          py: "12px",
        }}
      >
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.sm.regular,
            color: nawyTheme.nawy.colors.semantic.text.secondary,
          }}
        >
          {displayDate}
        </Typography>
      </Box>

      <Box>{children}</Box>
    </>
  );
};

export default NotificationsWrapper;
